import React from "react";
import { FaEnvelope, FaFileAlt, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import contactHero from "../images/contact-hero.jpg";
import { Hero, SectionHeader } from "../components/PremiumSections";
import SEO from "../components/SEO";

const emailTo = "info@dsglobalmachines.com";

const details = [
  "Company name and contact information",
  "Product, machine, component, material, or sourcing category",
  "Drawings, photos, specifications, or sample references when available",
  "Quantity, target timeline, destination, and documentation requirements",
  "Any quality, inspection, packaging, or export requirements",
];

const inquiryTypes = [
  "Industrial Machinery",
  "OEM Manufacturing",
  "Fabrication",
  "Porcelain Tiles",
  "Global Sourcing",
  "Paper Machinery",
];

export default function RFQ() {
  return (
    <main className="bg-white">
      <SEO title="Request a Quote | OEM Manufacturing, Fabrication & Porcelain Tiles" description="Send RFQ inquiries to DS Global Machines for OEM manufacturing, industrial fabrication, porcelain tile sourcing, machinery, and global procurement requirements." path="/contact/rfq" keywords={["RFQ OEM manufacturing", "fabrication quote", "porcelain tile quote", "industrial sourcing RFQ"]} />
      <Hero
        eyebrow="Request for quote"
        title="Send us your requirement. We will review it carefully."
        text="For machinery, OEM manufacturing, fabrication, porcelain tiles, or sourcing programs, email your RFQ details directly to DS Global Machines and our team will coordinate the next step."
        image={contactHero}
        actions={[{ label: "Email RFQ", to: `mailto:${emailTo}` }, { label: "Contact Us", to: "/contact" }]}
      />

      <section className="px-6 py-24">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div>
            <SectionHeader
              eyebrow="RFQ contact"
              title="Please send RFQ inquiries by email."
              text="This helps us review technical details, attachments, drawings, product photos, and sourcing documents with the right context."
            />
            <div className="mt-8 rounded border border-slate-200 bg-slate-50 p-6">
              <div className="flex items-center gap-4">
                <span className="grid h-12 w-12 place-items-center rounded bg-[#f4efe7] text-[#9a6a35]"><FaEnvelope /></span>
                <div>
                  <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#9a6a35]">Email</p>
                  <a href={`mailto:${emailTo}`} className="text-xl font-semibold text-[#101820] hover:text-[#9a6a35]">{emailTo}</a>
                </div>
              </div>
              <div className="mt-6 grid gap-4 text-sm text-slate-700 sm:grid-cols-2">
                <div className="flex gap-3"><FaPhoneAlt className="mt-1 text-[#9a6a35]" /><span>+1 (385) 461 4051</span></div>
                <div className="flex gap-3"><FaMapMarkerAlt className="mt-1 text-[#9a6a35]" /><span>Eagle Mountain, Utah, USA</span></div>
              </div>
            </div>
          </div>

          <div className="rounded border border-slate-200 bg-white p-8 shadow-xl">
            <div className="flex items-center gap-4">
              <span className="grid h-12 w-12 place-items-center rounded bg-[#f4efe7] text-[#9a6a35]"><FaFileAlt /></span>
              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#9a6a35]">Include in your RFQ</p>
                <h2 className="text-2xl font-semibold text-[#101820]">Information that helps us respond faster.</h2>
              </div>
            </div>
            <ul className="mt-8 space-y-4 text-sm leading-7 text-slate-700">
              {details.map((item) => <li key={item} className="border-b border-slate-100 pb-4 last:border-b-0 last:pb-0">{item}</li>)}
            </ul>
            <div className="mt-8 rounded bg-[#07111f] p-6 text-white">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#d6ad73]">Inquiry categories</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {inquiryTypes.map((item) => <span key={item} className="rounded border border-white/15 px-3 py-2 text-xs text-slate-200">{item}</span>)}
              </div>
            </div>
            <a href={`mailto:${emailTo}?subject=${encodeURIComponent("RFQ - DS Global Machines")}`} className="mt-8 inline-flex w-full items-center justify-center rounded bg-[#b8894d] px-6 py-3 text-sm font-semibold text-white hover:bg-[#a47942]">
              Email RFQ Details
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

